import styled, { css } from "styled-components";
import { colors, params } from "../../../../theme/Params";
import { device } from "../../utils";

const NameObject = css`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  white-space: normal;
  overflow-wrap: break-word;
`;

export const ScObjectsContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  flex-direction: column;
  padding: 8px;
  width: calc(100% + 16px);
  overflow: auto;
  height: calc(100vh - 424px);
`;

export const ScObjectButton = styled.div<{ type?: string }>`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  border: 1px solid;
  border-radius: 17px;
  padding: 0;
  cursor: pointer;
  width: 310px;

  ${(props) =>
    props.type === "polygon" &&
    css`
      height: 80px;
    `}

  ${(props) =>
    props.type === "segment" &&
    css`
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 40px;
    `}

  & > div {
    display: flex;
    align-items: center;
    height: 40px;

    & > span {
      ${NameObject}

      & select {
        width: 176px;
      }
    }

    &.pathology-params {
      border-top: 2px solid;

      & > .pathology-degrees {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        font-size: 11px;
        font-weight: 600;
        cursor: pointer;

        & > .degree {
          color: #ffffff;
          background: #6f6b7b;
          border-radius: 8px;
          padding: 2px 8px 2px 8px;
          transition: 0.1s;
          min-width: 40px;
          text-align: center;

          &.active {
            color: #000000;
            background: #ffc803;
            border: 1px solid #6f6b7b;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  & select {
    font-size: 12px;
    font-weight: 600 !important;
    cursor: pointer;
  }

  .input-name-object {
    background: none;
    padding: 0;
    margin: 0;

    ${NameObject}

    & > * {
      font-size: 16px;
      font-weight: 600;
      background: none;
      color: #727281;
    }

    & > *:focus {
      outline: none;
    }
  }

  .icon-container {
    margin-top: -16px;
  }

  &.active {
    cursor: default;

    .control-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      border-left: 2px solid;
      margin-left: 5px;

      &.square-polygon {
        width: 88px;
        font-size: 12px;
        font-weight: 600;
      }

      & > button {
        margin-bottom: 4px;
      }
    }

    > .icon-container {
      svg {
        transform: rotate(-90deg);
      }
    }
  }

  .control-item {
    position: relative;
    display: flex;
    gap: 5px;
    width: 30px;
    transition: all 0.4s;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      border: none;
      border-radius: 14px !important;
      height: 30px;
      width: 40px;

      .icon-container {
        margin-right: 0;
      }

      :hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .react-colorful {
    position: absolute;

    bottom: 24px;
    right: -38px;
  }

  & > .control-item {
    & > button {
      margin-top: 0;
    }
  }
`;

interface ScModalProps {
  width?: number;
}

export const ScModal = styled.div<ScModalProps>`
  width: ${(props) => (props.width ? props.width.toString() + "px" : "579px")};
  background-color: white;
  color: ${colors.grey95};
  border: none;
  border-radius: ${params.containerBlockRadius};
  box-shadow: ${params.boxShadow};
  padding: 42px 20px;
  position: relative;
  @media (${device.mobileM}) {
    width: 100%;
  }

  .modal-header {
    padding-bottom: 40px;

    .close {
      height: 34px;
      width: 34px;
      border: none;
      box-shadow: ${params.boxShadow};
      background: white;
      padding: 5px 4px;
      position: absolute;
      right: -7px;
      top: -7px;
    }
  }

  .modal-body {
    h3 {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 17px;
      line-height: 21px;
      font-weight: 500;
    }

    p {
      font-size: 16px;
    }

    .half {
      display: flex;
      flex-direction: row;
      align-content: stretch;
      gap: 16px;
      @media (${device.mobileM}) {
        flex-direction: column;
      }

      div {
        flex-grow: 1;
      }
    }

    .buttons {
      margin-top: 50px;
      display: flex;
      gap: 16px;
      justify-content: end;
      @media (${device.mobileM}) {
        flex-direction: column;
      }
    }
  }

  .modal-save {
    text-align: center;
    .buttons {
      justify-content: center;
    }
  }
`;

export const ScModalPathology = styled.div`
  .modal-pathology {
    position: fixed;
    display: flex;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;

    & > .modal-pathology-content {
      position: relative;
      background: white;
      border: 2px solid #bfbfc0;
      border-radius: 8px;
      padding: 24px 32px 16px 32px;
      box-shadow: 4px 4px 24px #bfbfc0;
      width: 60%;
      height: 85%;
      top: 5%;

      & > .close-modal {
        position: absolute;
        font-size: 48px;
        font-weight: bold;
        transition: 0.3s;
        cursor: pointer;
        top: 0;
        left: 94%;
        color: rgba(26, 28, 33, 0.5);
      }

      & .close-modal:hover,
      & .close-modal:focus {
        color: rgba(26, 28, 33, 0.3);
        text-decoration: none;
        cursor: pointer;
      }

      & > div.content-modal {
        & > .modal-pathology-title {
          padding-bottom: 32px;
        }

        padding: 8px 8px;

        width: 100%;
        height: 100%;
        overflow: auto;
      }
    }
  }
`;

export const ScSelectMultiple = styled.div`
  padding-left: 16px;
  width: 208px;
  cursor: pointer;
  position: relative;

  .options-container {
    z-index: 100;
    position: absolute;
    & > .options {
      border: 1px solid #cdd4da;

      & > .option {
        display: grid;
        background: #ffffff;
        color: #495057;
        align-items: center;
        grid-template-columns: 24px auto;
        grid-column-gap: 4px;
        padding-left: 8px;
        padding-right: 8px;
        cursor: pointer;
        height: 40px;
        width: 216px;
        font-size: 12px;
        border-bottom: 1px solid #cdd4da;
      }

      .option:last-child {
        border-bottom: none;
      }
    }
  }

  .select-label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > .title {
      font-size: 12px;
      font-weight: 600 !important;
      width: 164px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
